import React, { useState } from 'react';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Asset, PrimaryButton } from '@hz-design-system/web-ui';

import { TListingClient } from 'types/TListing';

import Classes from './NapCarPassLogo.module.scss';

type TNapCarPassLogoProps = {
  carDetails?: TListingClient['carDetails'];
};

let NapCarPassModal;

const NapCarPassLogo = ({ carDetails }: TNapCarPassLogoProps) => {
  const { t } = useI18nContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isNapCarPassModalLoaded, setNapCarPassModalLoaded] = useState(false);
  let assetName;
  let logoClassName;

  const isAssetClickable = Boolean(carDetails?.licensePlate || carDetails?.carPassUrl);

  if (carDetails?.hasNapStatus) {
    assetName = 'LogoNap';
    logoClassName = Classes.logoNap;
  }

  if (carDetails?.carPassUrl) {
    assetName = 'LogoCarPass';
    logoClassName = Classes.logoCarPass;
  }

  if (!assetName) {
    return null;
  }

  const loadNapCarPassModal = async () => {
    if (!isNapCarPassModalLoaded) {
      try {
        if (carDetails?.carPassUrl) {
          NapCarPassModal = (
            await import(
              /* webpackChunkName: "BasicModalWithFooter" */ '@hz-design-system/web-ui/lib/components/Modal/BasicModalWithFooter'
            )
          ).default;
        } else {
          NapCarPassModal = (
            await import(
              /* webpackChunkName: "BasicModal" */ '@hz-design-system/web-ui/lib/components/Modal/BasicModal'
            )
          ).default;
        }
        setNapCarPassModalLoaded(true);
      } catch {}
    }
  };

  const handleClick = async () => {
    await loadNapCarPassModal();
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const confirm = {
    text: t('listing.modal.napCarPass.confirm'),
    onClick: () => {
      handleClose();

      if (carDetails?.carPassUrl) {
        window.open(carDetails?.carPassUrl, '_blank');
      }
    },
  };

  if (!isAssetClickable) {
    return (
      <Asset.Fluid
        className={`${Classes.root} ${logoClassName}`}
        name={assetName}
        alt={t('listing.modal.napCarPass.title')}
      />
    );
  }
  const buttons = [
    {
      element: <PrimaryButton onClick={confirm.onClick}>{confirm.text}</PrimaryButton>,
    },
  ];
  return (
    <>
      <button
        onClick={handleClick}
        className={`${Classes.root} ${Classes.assetButton}`}
        aria-label={t('listing.modal.napCarPass.title')}
      >
        <Asset.Fluid className={logoClassName} name={assetName} />
      </button>
      {isOpen && isNapCarPassModalLoaded && (
        <NapCarPassModal
          title={t('listing.modal.napCarPass.title')}
          size="s"
          buttons={buttons}
          onClose={handleClose}
          buttonsAlignmentMobile="stacked"
          buttonsAlignmentDesktop="stacked"
        >
          <Trans i18nKey={'listing.modal.napCarPass.text'} tagName="span" licensePlate={carDetails?.licensePlate} />
        </NapCarPassModal>
      )}
    </>
  );
};

export default NapCarPassLogo;
